import { Modal } from "react-bootstrap";
import "./files.scss";
import cross from "../../images/cross.svg";
import parse from "html-react-parser";

const ProcessingDataModal = ({ personalDataPolicy, ...props }) => {
  return (
    <Modal {...props} size="lg" aria-labelledby="contained-modal-title-vcenter" centered backdrop="static">
      <Modal.Body className="info-modal">
        <p>
          <img src={cross} className="info-modal-img" onClick={props.onHide} alt="" />
        </p>
        <div className="info-modal-main">
          <p className="info-modal-title">Политика конфиденциальности</p>

          <p className="info-modal-text">{parse(personalDataPolicy.replace(/style="[^"]+"/g))}</p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ProcessingDataModal;
